import gql from 'graphql-tag';

export const allowMonLogTypeDelete = gql`
  query allowMonLogTypeDelete($id: String) {
    allowMonLogTypeDelete(id: $id) {
      value
    }
  }
`;
